var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Model } from '../../Core';
import { ErrorCodes, ExceptionHandlerClass } from '../../System/Aop';
var ModelV5 = (function (_super) {
    __extends(ModelV5, _super);
    function ModelV5(id, projection) {
        var _this = _super.call(this, id) || this;
        _this.___init(id, projection);
        return _this;
    }
    ModelV5_1 = ModelV5;
    Object.defineProperty(ModelV5.prototype, "UniqueID", {
        get: function () {
            return this.id;
        },
        set: function (value) {
            this.id = value;
        },
        enumerable: false,
        configurable: true
    });
    ModelV5.prototype.___init = function (id, projection) {
        this.id = id;
        this.references = {};
        this.referencedBy = {};
        if (projection) {
            this.references = projection.References ? projection.References : {};
            this.mapperId = projection.MapperId;
            this.eventChanges = projection.EventChanges ? projection.EventChanges : {};
            this.stylePivot = projection.Style ? projection.Style : {};
        }
        this.addProperties(projection);
    };
    ModelV5.prototype.addReferencedBy = function (modelId, name) {
        this.referencedBy[modelId] = name;
    };
    ModelV5.prototype.removeReference = function (name) {
        delete this.references[name];
        delete this[name];
    };
    ModelV5.prototype.applyOnProperties = function (item, fn) {
        for (var prop in item) {
            if (item.hasOwnProperty(prop) && ModelV5_1.myInternalProperties.indexOf(prop) === -1) {
                fn.call(this, prop);
            }
            else if (prop === ModelV5_1.myInternalProperties[2]) {
                this.applyReferencesDeltas(item);
            }
        }
    };
    ModelV5.prototype.applyReferencesDeltas = function (projection) {
        for (var ref in projection.References) {
            if (projection.References.hasOwnProperty(ref)) {
                this.references[ref] = projection.References[ref];
            }
        }
    };
    ModelV5.prototype.addProperties = function (obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key) && ModelV5_1.myInternalProperties.indexOf(key) === -1) {
                this[key] = obj[key];
            }
        }
    };
    var ModelV5_1;
    ModelV5.myInternalProperties = ['Id', 'MapperId', 'References', 'EventChanges', '_internalProperties',
        'childrenToNotify', 'onModelChange', '_isTempModel', '_pointers', 'Style'];
    ModelV5 = ModelV5_1 = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore),
        __metadata("design:paramtypes", [String, Object])
    ], ModelV5);
    return ModelV5;
}(Model));
export { ModelV5 };
